import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {X} from "utruckin-icons"
import {onMounted, ref, watch} from 'vue'
import {useSearchStore} from "@/features/search/search.store";


export default /*@__PURE__*/_defineComponent({
  __name: 'globalSearchInput',
  setup(__props) {

const searchStore = useSearchStore()

const inputRef = ref<HTMLInputElement | null>(null)
const loading = ref<boolean>(false);
let timeout: ReturnType<typeof setTimeout>
let controller: AbortController | null = null

const focusInput = () => {
  inputRef.value?.focus()
}

const clearInput = () => {
  searchStore.smartSearchFilter.q = ''
}

const getSmartSearch = async () => {
  if (controller) controller.abort()
  controller = new AbortController()

  try {
    await searchStore.smartSearch(loading, controller.signal)
  } catch (error: any) {
    if (error.name === 'CanceledError' || error.name === 'AbortError') {
      return
    }
  }
}

onMounted(() => {
  getSmartSearch()
})

watch(
    () => JSON.stringify(searchStore.smartSearchFilter),
    () => {
      if (!searchStore.smartSearchFilter.q.trim()) {
        controller?.abort()
        return
      }
      clearTimeout(timeout)

      timeout = setTimeout(() => {
        getSmartSearch()
      }, 500)
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "w-ui-search",
    onClick: focusInput
  }, [
    _withDirectives(_createElementVNode("input", {
      ref_key: "inputRef",
      ref: inputRef,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchStore).smartSearchFilter.q) = $event)),
      type: "text",
      placeholder: "Search for all..."
    }, null, 512), [
      [_vModelText, _unref(searchStore).smartSearchFilter.q]
    ]),
    _createElementVNode("div", {
      class: "action",
      onClick: clearInput
    }, [
      _createVNode(_unref(X), { size: 16 })
    ])
  ]))
}
}

})